import { Controller } from '@hotwired/stimulus'
// Cleave is deprecated, and we only use it a couple places. We could probably refactor to get rid of it.
import Cleave from 'cleave.js'

type Mode = 'scalar' | 'currency' | 'percent'

const CURRENCY_OPTIONS = {
  numeral: true,
  numeralThousandsGroupStyle: 'thousand',
}

const PERCENT_OPTIONS = {
  numeral: true,
  numeralDecimalScale: 8,
  numeralThousandsGroupStyle: 'thousand',
}

const SCALAR_OPTIONS = {
  numeral: true,
  numeralDecimalScale: 3,
  numeralPositiveOnly: true,
  numeralThousandsGroupStyle: 'thousand',
}

export default class NumberInputController extends Controller<HTMLInputElement> {
  declare modeValue: Mode
  declare formattedTarget: HTMLInputElement
  declare rawTarget: HTMLInputElement

  static targets = ['formatted', 'raw']
  static values = {
    mode: { type: String, default: 'scalar' },
  }

  connect() {
    if (this.hasRawTarget && !this.hasFormattedTarget) {
      const formattedEl = this.rawTarget.cloneNode()<HTMLElement>
      formattedEl.removeAttribute('name')
      formattedEl.removeAttribute('id')
      formattedEl.setAttribute('data-number-input-target', 'formatted')
      this.rawTarget.insertAdjacentElement('afterend', formattedEl)

      this.rawTarget.setAttribute('type', 'hidden')
    }
  }

  formattedTargetConnected() {
    this.#buildCleave(this.modeValue)
  }

  formattedTargetDisconnected(el: HTMLInputElement) {
    el.remove()
  }

  rawTargetDisconnected(el: HTMLInputElement) {
    el.setAttribute('type', 'text')
  }

  handleValueChange = (event: Event) => {
    if (this.hasRawTarget) {
      this.rawTarget.value = event.target.rawValue
    }

    this.element.dispatchEvent(
      new CustomEvent('number-input:changed', {
        bubbles: true,
        detail: event.target,
      }),
    )
  }

  // Likely to change? No.
  modeValueChanged(newValue: Mode, oldValue: Mode) {
    if (newValue === oldValue) return
    if (this.cleave) this.#buildCleave(newValue)
  }

  #buildCleave(mode: Mode) {
    if (!this.hasFormattedTarget) return
    this.cleave?.destroy()
    const baseOptions = {
      onValueChanged: this.handleValueChange,
    }
    let cleaveOptions = null

    switch (mode) {
      case 'scalar':
        cleaveOptions = Object.assign(baseOptions, SCALAR_OPTIONS)
        break
      case 'currency':
        cleaveOptions = Object.assign(baseOptions, CURRENCY_OPTIONS)
        break
      case 'percent':
        cleaveOptions = Object.assign(baseOptions, PERCENT_OPTIONS)
        break
    }

    if (cleaveOptions) {
      this.cleave = new Cleave(this.formattedTarget, cleaveOptions)
      this.formattedTarget.value = this.cleave.getFormattedValue()
    }
  }
}
